/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-10 14:05:30
 *
 *******************************************************/
// @flow
//
import React, { Component } from 'react';
import { Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import alphalete from 'src/assets/images/subscription-v3/alphalete.png';
import bbc from 'src/assets/images/subscription-v3/bbc.png';
import audistore from 'src/assets/images/subscription-v3/audistore.png';
import tupperware from 'src/assets/images/subscription-v3/tupperware.png';
import sony from 'src/assets/images/subscription-v3/sony.png';
import ford from 'src/assets/images/subscription-v3/ford.png';
import crocs from 'src/assets/images/subscription-v3/crocs.png';
import gap from 'src/assets/images/subscription-v3/gap.png';
import lacoste from 'src/assets/images/subscription-v3/lacoste.png';
import guess from 'src/assets/images/subscription-v3/guess.png';
import mavi from 'src/assets/images/subscription-v3/mavi.png';

class PlansReview extends Component<WithI18nProps> {
  renderBrand = () => {
    const { i18n } = this.props;
    const brandsRow1 = [
      { src: alphalete, style: { maxWidth: '164px', maxHeight: '40x' }, alt: 'alphalete' },
      { src: bbc, style: { maxWidth: '138px', maxHeight: '40px' }, alt: 'bbc' },
      { src: audistore, style: { maxWidth: '139px', maxHeight: '40px' }, alt: 'audistore' },
      { src: tupperware, style: { maxWidth: '141px', maxHeight: '40px' }, alt: 'tupperware' },
      { src: sony, style: { maxWidth: '94px', maxHeight: '40px' }, alt: 'sony' }
    ];
    const brandsRow2 = [
      { src: ford, style: { maxWidth: '73px', maxHeight: '40px' }, alt: 'ford' },
      { src: crocs, style: { maxWidth: '93px', maxHeight: '40px' }, alt: 'crocs' },
      { src: gap, style: { maxWidth: '41px', maxHeight: '40px' }, alt: 'gap' },
      { src: lacoste, style: { maxWidth: '158px', maxHeight: '40px' }, alt: 'lacoste' },
      { src: guess, style: { maxWidth: '101px', maxHeight: '40px' }, alt: 'guess' },
      {
        src: mavi,
        style: { maxHeight: '40px' },
        alt: 'mavi'
      }
    ];
    return (
      <div className="plan-review-brand">
        <div className="align-center card-title-uppercase">
          <Heading>{i18n.translate('AdminHTML.SubscriptionV3.Subscription.brandsTrustUs')}</Heading>
        </div>
        <div className="brand-items">
          {brandsRow1.map((item, index) => (
            <img className="icon" src={item.src} alt={item.alt} style={item.style} key={index} />
          ))}
        </div>
        <div className="brand-items">
          {brandsRow2.map((item, index) => (
            <img className="icon" src={item.src} alt={item.alt} style={item.style} key={index} />
          ))}
        </div>
      </div>
    );
  };

  render() {
    return <div>{this.renderBrand()}</div>;
  }
}

export default withI18n()(PlansReview);
